// Tilted like the physical tool, so the silhouette reads as an eraser rather
// than a plain block at the sizes the toolbars use it (14–20px). Composed from
// an axis-aligned block plus its rubber band, then rotated as a group — the
// alternative, baking the rotation into the path data, hides the geometry.
export const eraser = (
  <g transform="rotate(-45 14 14)" fill="currentColor">
    {/* The block, hollow: a solid slab loses its shape against a filled
        segment, which is exactly where this icon sits when Erase is active. */}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.5 6h9A2.5 2.5 0 0 1 21 8.5v11a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 7 19.5v-11A2.5 2.5 0 0 1 9.5 6Zm0 2a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-11a.5.5 0 0 0-.5-.5h-9Z"
    />
    {/* Where the rubber meets the sleeve. */}
    <path d="M9 14.5h10v1.75H9z" />
  </g>
);
